// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3olcq","row":"ProcedureTreatmentSummary_row__n6axg"};